<div class="fuel-request-form">
    <div class="row">
        <div class="col-sm-6 col-12">
            <div class="form-group">
                <label for="fuelDateTime">Date/Time</label>
                <wj-input-date-time
                    [(ngModel)]="fuelRequest().dateTime"
                    name="fuelDateTime"
                    id="fuelDateTime"
                    [isRequired]="false"
                ></wj-input-date-time>
            </div>
        </div>
        <div class="col-sm-6 col-12">
            <div class="form-group">
                <label for="fuelJob">Job</label>
                <wj-combo-box
                    [(ngModel)]="fuelRequest().job"
                    name="fuelJob"
                    id="fuelJob"
                    [itemsSource]="jobOptions()"
                    [displayMemberPath]="'display'"
                    [selectedValuePath]="'value'"
                ></wj-combo-box>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-6 col-12">
            <div class="form-group">
                <label for="fuelOperatorName">Operator Name</label>
                <wj-combo-box
                    [(ngModel)]="fuelRequest().operatorName"
                    name="fuelOperatorName"
                    id="fuelOperatorName"
                    [itemsSource]="employeeOptions()"
                    [displayMemberPath]="'display'"
                    [selectedValuePath]="'value'"
                ></wj-combo-box>
            </div>
        </div>
        <div class="col-sm-6 col-12">
            <div class="form-group">
                <label for="fuelEquipmentNumber">Equipment #</label>
                <wj-combo-box
                    [(ngModel)]="fuelRequest().equipmentNumber"
                    name="fuelEquipmentNumber"
                    id="fuelEquipmentNumber"
                    [itemsSource]="equipmentOptions()"
                    [displayMemberPath]="'display'"
                    [selectedValuePath]="'value'"
                ></wj-combo-box>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-6 col-12">
            <div class="form-group">
                <label for="currentFuelLevel">Current Fuel Level</label>
                <wj-combo-box
                    [(ngModel)]="fuelRequest().currentFuelLevel"
                    name="currentFuelLevel"
                    id="currentFuelLevel"
                    [itemsSource]="fuelLevelOptions"
                    [displayMemberPath]="'display'"
                    [selectedValuePath]="'value'"
                ></wj-combo-box>
            </div>
        </div>
        <div class="col-sm-6 col-12">
            <div class="form-group">
                <label for="fuelTypeRequired">Fuel Type Required</label>
                <wj-combo-box
                    [(ngModel)]="fuelRequest().fuelTypeRequired"
                    name="fuelTypeRequired"
                    id="fuelTypeRequired"
                    [itemsSource]="fuelTypeOptions"
                    [displayMemberPath]="'display'"
                    [selectedValuePath]="'value'"
                ></wj-combo-box>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-6 col-12">
            <div class="form-group">
                <label for="isEquipmentRunning">Is Equipment Currently Running?</label>
                <wj-combo-box
                    [(ngModel)]="fuelRequest().isEquipmentRunning"
                    name="isEquipmentRunning"
                    id="isEquipmentRunning"
                    [itemsSource]="equipmentRunningOptions"
                    [displayMemberPath]="'display'"
                    [selectedValuePath]="'value'"
                ></wj-combo-box>
            </div>
        </div>
        <div class="col-sm-6 col-12">
            <div class="form-group">
                <label for="priorityLevel">Priority Level</label>
                <wj-combo-box
                    [(ngModel)]="fuelRequest().priorityLevel"
                    name="priorityLevel"
                    id="priorityLevel"
                    [itemsSource]="priorityLevelOptions"
                    [displayMemberPath]="'display'"
                    [selectedValuePath]="'value'"
                ></wj-combo-box>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <div class="form-group">
                <label for="fuelAdditionalNotes">Additional Notes / Issues</label>
                <textarea
                    rows="3"
                    class="form-control"
                    [(ngModel)]="fuelRequest().additionalNotes"
                    name="fuelAdditionalNotes"
                    id="fuelAdditionalNotes"
                    placeholder="Enter any additional notes..."
                ></textarea>
            </div>
        </div>
    </div>
</div>
